import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD8W_yvC6DDwqameOnAmq3ZeElCC9NEjrk",
  authDomain: "service-tracek-app.firebaseapp.com",
  projectId: "service-tracek-app",
  storageBucket: "service-tracek-app.firebasestorage.app",
  messagingSenderId: "390905347665",
  appId: "1:390905347665:web:2aa99dd31ea927cbcec270"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();